__webpack_require__.p = "https://cdn-dev-np.transition.quickorganics.com/_next/";